import React, { useContext, useEffect, useState } from "react";
import SideDrawer from '../side-drawer/hoa-side-drawer';
import Header from '../header/hoa-header';

import './hoa-layout.scss';
import { GlobalContext } from '../../context/hoa-global-context';
import HOADashboard from "../hoas/hoa-main-dashboard";
import MuncipalitiesDashboard from "../municipalities/hoa-muncipalities-dashboard";
import PropertyDashboard from "../properties/hoa-property-dashboard";

import useMobileViewEnabled from '../../hooks/useMobileView';
import datastore from "../../store/hoa-datastore";
import MailsDashboard from "../mails/hoa-mail-dashboard";
import RequestsDashboard from "../requests/hoa-request-dashboard";
import DocumentsDashboard from "../documents/hoa-document-dashboard";
import InvoicingDashboard from "../invoicing/hoa-invoicing-dashboard";
import TriggerNotification from "../trigger-notification/hoa-trigger-notification";
import EmailsDashboard from "../emails/hoa-email-dashboard";
import config from "../../hoa-config";
import DataFieldConfigurator from "../data-field-configurator/hoa-configurator-dashboard";
import PropertyTaskDashboard from '../property-task/property-task-dashboard';
import PropertyCompletedTaskDashboard from '../property-task/property-completed-task/property-completed-task-dashboard';
import PendingSourceDashboard from "../pending-source/pending-source-dashboard";
import InvoiceManagerDashboard from "../invoice-manager/InvoiceManagerDashboard";

const ResponsiveWidth = (isMobileView:boolean) => {
    let dashboardWidth = "";
    let sideDrawer = 272;
    let padding = 2 * 16;
    let defaultWidth = 1200;
    if(isMobileView){
        datastore.responsiveWidthOfMainDashboard = window.innerWidth - padding;
        dashboardWidth = `${datastore.responsiveWidthOfMainDashboard}px`;
    } else {
        if(window.innerWidth-sideDrawer < defaultWidth) {
            datastore.responsiveWidthOfMainDashboard = window.innerWidth-sideDrawer-padding;
            dashboardWidth = `${datastore.responsiveWidthOfMainDashboard}px` 
        } else {
            datastore.responsiveWidthOfMainDashboard = defaultWidth;
            dashboardWidth = `${datastore.responsiveWidthOfMainDashboard}px`;
        }
    }

    return dashboardWidth;
}

const Layout = () => {
    const { activeMenu } = useContext<any>(GlobalContext);
    const { isMobileView } = useMobileViewEnabled();
    const [responsiveWidth, setResponsiveWidth] = useState(ResponsiveWidth(isMobileView))

    useEffect(()=>{
        const handleSize = ()=>setResponsiveWidth(ResponsiveWidth(isMobileView));
        window.addEventListener('resize', handleSize);
        return ()=>{
            window.addEventListener('resize',handleSize); 
        }
    },[])

    const menuComponentMap:any = {
        'hoas': <HOADashboard />,
        'municipalities': <MuncipalitiesDashboard />,
        'properties': <PropertyDashboard />,
        'mails': <MailsDashboard />,
        'emails': <EmailsDashboard />,
        'requests': <RequestsDashboard />,
        'documents': <DocumentsDashboard />,
        'invoicing': <InvoicingDashboard />,
        'webhook': <TriggerNotification />,
        'datafieldconfigurator': <DataFieldConfigurator/>,
        'propertiespendingtask': <PropertyTaskDashboard />,
        'propertiescompletedtask': <PropertyCompletedTaskDashboard />,
        'pendingsource': <PendingSourceDashboard />,
        'invoicedatamapping': <InvoiceManagerDashboard />
    };

    const clientMenuComp: any = {
        'hoas': <HOADashboard />,
        'properties': <PropertyDashboard />,
        'municipalities': <MuncipalitiesDashboard />,
    }

    return (
        <div className="layout-container">
            <SideDrawer />
            <main className="layout-main-container">
                <Header />
                <div className="layout-main-component" style={{ height: `${window.innerHeight - 98}px`, width: '100%' }}>
                    <div className="main-dashboard-container" style={{ width: responsiveWidth, background:activeMenu==="datafieldconfigurator"?'transparent':'white' }}>
                        {/* {menuComponentMap[activeMenu] || <></>} */}
                        {
                            datastore.userRole === config.userRoles.OrganizationUser ? 
                                clientMenuComp[activeMenu] : menuComponentMap[activeMenu]
                        }
                    </div>
                </div>
            </main>
        </div>
    )
}


export default Layout;